import axios from 'axios'
import getConfig from '@/utils.js'
import { useAuthStore } from '@/stores/auth'
import { useAlertStore } from '@/stores/alert'

// Create an axios instance
const client = axios.create({
  baseURL: getConfig().merchantApiUrl,
  timeout: 5000 // request timeout
})

// Request interceptor to add JWT token
client.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    const alertStore = useAlertStore()

    const token = authStore.jwt
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    alertStore.axiosBusyInc()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
client.interceptors.response.use(
  (response) => {
    const alertStore = useAlertStore()
    alertStore.axiosBusyDec()
    return response
  },
  (error) => {
    const alertStore = useAlertStore()
    alertStore.axiosBusyDec()

    let message = {
      type: 'error'
    }

    if (error.response) {
      message.message = `HTTP ${error.response.status}: ${error.response.data.message}`

      // Handle 401 Unauthorized
      if (error.response.status === 401) {
        const authStore = useAuthStore()
        authStore.removeToken()
        window.location.href = '/' // Redirect to login
      }
    } else if (error.request) {
      message.message = 'Could not send request: ' + error.request
    } else {
      message.message = 'Unknown axios error: ' + error.message
    }

    alertStore.add(message)
    return Promise.reject(error)
  }
)

// Request wrapper function
export async function request(args) {
  try {
    const response = await client.request(args)
    return response.data
  } catch (error) {
    // Error already handled in interceptor
    throw error
  }
}

export default client
